import { render, staticRenderFns } from "./ReturnFormRedirect.vue?vue&type=template&id=ba9be29c&"
import script from "./ReturnFormRedirect.vue?vue&type=script&lang=js&"
export * from "./ReturnFormRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports